import * as React from 'react';

import styles from './quotas-empty-state.module.css';

export class QuotasEmptyState extends React.Component {
    render() {
        return (
            <div className={styles.container}>
                Preview unavailable
                <br />
                Try selecting a user and a quota type
            </div>
        );
    }
}
